import { useRef, useMemo } from 'react';
import { useFrame, useLoader, extend } from '@react-three/fiber';
import { Water } from 'three-stdlib';
import * as THREE from 'three';
import { TextureLoader, RepeatWrapping, Vector3 } from 'three';

extend({ Water });

export default function Ocean()
{
    const waterRef = useRef();
    const waterNormals = useLoader(TextureLoader, './Textures/waternormals.jpg');
    
    waterNormals.wrapS = waterNormals.wrapT = RepeatWrapping;

    const waterGeometry = useMemo(() => {
        return new THREE.PlaneGeometry(10000, 10000);
    }, []);

    const config = useMemo(() => ({
        textureWidth: 512,
        textureHeight: 512,
        waterNormals: waterNormals,
        sunDirection: new Vector3(),
        sunColor: 0xffffff,
        waterColor: 0x001e0f,
        distortionScale: 3.7,
        fog: true
    }), [waterNormals]);

    useFrame((state, delta) => {
        if (waterRef.current) {
            waterRef.current.material.uniforms.time.value += delta;
        }
    });

    return (
        <water
            ref={waterRef}
            args={[waterGeometry, config]}
            rotation-x={-Math.PI / 2}
            position={[0, -0.3, 0]}
        />
    )
}
